import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChecklistConfig, QuestionLocationMap, QuestionMap } from "../../types/checklist";

export interface ChecklistState {
    config: ChecklistConfig | null;
    questionMap: QuestionMap;
    questionLocationMap: QuestionLocationMap;
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
    currentChecklistType: string | null;
    currentVersion: string | null;
}

export const initialState: ChecklistState = {
    config: null,
    questionMap: {},
    questionLocationMap: {},
    loading: false,
    error: false,
    errorMessage: null,
    currentChecklistType: null,
    currentVersion: null,
};

export const checklistSlice = createSlice({
    name: "checklist",
    initialState,
    reducers: {
        setConfig: (state, action: PayloadAction<{ config: ChecklistConfig; questionMap: QuestionMap; questionLocationMap: QuestionLocationMap }>) => {
            state.config = action.payload.config;
            state.questionMap = action.payload.questionMap;
            state.questionLocationMap = action.payload.questionLocationMap;
            state.currentChecklistType = action.payload.config.checklistType;
            state.currentVersion = action.payload.config.version;
            state.error = false;
            state.errorMessage = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload !== null;
            state.errorMessage = action.payload;
        },
        clearChecklist: (state) => {
            state.config = null;
            state.questionMap = {};
            state.questionLocationMap = {};
            state.currentChecklistType = null;
            state.currentVersion = null;
            state.error = false;
            state.errorMessage = null;
        },
    },
});

export const { setConfig, setLoading, setError, clearChecklist } = checklistSlice.actions;

export default checklistSlice.reducer;
